export enum ServiceChatBookingStatus {
  OPEN = "OPEN",
  PENDING = "PENDING",
  CLOSED = "CLOSED"
}

export interface ServiceChatBooking {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  status: ServiceChatBookingStatus;
  createdAt: string;
  lastUpdatedAt?: string;
  lastUpdatedBy?: string;
  message?: string;
}

export interface ServiceChatBookingRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  message?: string;
}

export interface addServiceChatBookingResponse {
  addServiceChatBooking: ServiceChatBooking;
}

export interface UpdateServiceChatStatusInput {
  id: string;
  status: ServiceChatBookingStatus;
}

export interface UpdateServiceChatStatusResponse {
  updateServiceChatBooking: ServiceChatBooking;
}

export interface GetServiceChatBookingResponse {
  getAllServiceChatBooking: ServiceChatBooking[];
}

export interface GetServiceChatBookingByIdResponse {
  getServiceChatBookingById: ServiceChatBooking;
}
